let Index = () => import(/* webpackChunkName: "dome" */ '@/views/_lang/protocol.vue')

export default [{ path: '/:lang/protocol', name: 'Protocol', component: Index, meta: { isLogin: false, level: '2,4,999' } }]
